import { type AppThunk } from "../../../index";
import { unsubscribeFromTeam as action } from "../reducer";
import { closeRealtimeChannel } from "../../../helpers/closeRealtimeChannel";
import { claimRealtimeSlot } from "../../../helpers/realtimeSlot";

export const unsubscribeFromTeam =
  (): AppThunk =>
  async (dispatch, _, { subscriptions, db }) => {
    // take the slot so a subscribe still waiting on its fetch does not resurrect the channel
    claimRealtimeSlot(subscriptions, "team");

    // detach synchronously - awaiting the close first would let a subscribe that
    // already claimed the slot store its channel, only for this thunk to null it out
    const channel = subscriptions.realtimeTeamListChannel;
    subscriptions.realtimeTeamListChannel = null;
    subscriptions.teamListChannelName = null;
    void closeRealtimeChannel(db, channel);
    dispatch(action());
  };
